import React, { type ReactNode } from 'react';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import { FREE_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { messages } from './messages';

const SUPPORT_LINK_EVALUATOR = 'https://support.atlassian.com/contact/#/';

export const EditDisabledBanner = () => {
	const { formatMessage } = useIntl();
	const { appEditions } = useTenantContext();

	const isFree = appEditions.serviceDesk === FREE_EDITION;

	return (
		<Box xcss={sectionMessageContainerStyles}>
			{isFree ? (
				<SectionMessage
					title={formatMessage(messages.titleFree)}
					actions={[
						<SectionMessageAction key="1">
							<Button
								appearance="link"
								href="/admin/billing/applications"
								target="_blank"
								spacing="none"
							>
								{formatMessage(messages.ctaFree)}
							</Button>
						</SectionMessageAction>,
					]}
				>
					<FormattedMessage {...messages.messageFree} />
				</SectionMessage>
			) : (
				<SectionMessage appearance="information" title={formatMessage(messages.titleEvaluating)}>
					{formatMessage(messages.messageEvaluating, {
						link: (chunks: ReactNode[]) => (
							<a href={SUPPORT_LINK_EVALUATOR} target="_blank">
								{chunks}
							</a>
						),
					})}
				</SectionMessage>
			)}
		</Box>
	);
};

const sectionMessageContainerStyles = xcss({
	marginTop: 'space.150',
	marginBottom: 'space.150',
});
